<template>
    <div class="serve-content">
        <div class="serve-content-content">
            <div class="serve-content-content-left">
                <div class="serve-content-content-left-content " :class="active == 0 ? 'active' : ''"
                    @click="handleClick(companyInfo.beijing, 0)">
                    <div class="serve-content-content-left-content-name ">北京(总部)</div>
                    <div>北京市海淀区清华东路 35 号北京林业大学学研中心C栋二层C201室</div>
                </div>
                <div class="serve-content-content-left-content" :class="active == 1 ? 'active' : ''"
                    @click="handleClick(companyInfo.zhengzhou, 1)">
                    <div class="serve-content-content-left-content-name">郑州(分公司)</div>
                    <div>河南省郑州市金水区大华股份河南智慧物联基地A栋7楼702室</div>
                </div>
                <div class="serve-content-content-left-content" :class="active == 2 ? 'active' : ''"
                    @click="handleClick(companyInfo.xian, 2)">
                    <div class="serve-content-content-left-content-name">西安办事处</div>
                    <div>陕西省西安市雁塔区太白南路2号西安电子科技大学北校区</div>
                </div>
                <div class="serve-content-content-left-content" :class="active == 3 ? 'active' : ''"
                    @click="handleClick(companyInfo.hulunbeier, 3)">
                    <div class="serve-content-content-left-content-name">呼伦贝尔办事处</div>
                    <div>内蒙古自治区呼伦贝尔市海拉尔区城头望园一号楼101门市</div>
                </div>
            </div>
            <div class="serve-content-content-right" ref="mapboxDom"></div>
        </div>
    </div>
    <div class="serve-content-phone">
        <img src="../../assets/image/home/phone.png" alt="">
    </div>

</template>

<script setup>
import { onMounted, ref } from "vue"
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { accessToken, style } from "./config"

const active = ref(0)

const mapboxDom = ref()
const companyInfo = {
    beijing: {
        name: '北京畅图科技有限公司',
        lonlat: [116.342, 40.00]
    },
    zhengzhou: {
        name: '北京畅图科技有限公司（郑州分公司）',
        lonlat: [113.7085, 34.8315]
    },
    xian: {
        name: "陕西省西安市雁塔区太白南路2号西安电子科技大学北校区",
        lonlat: [108.912856, 34.234363]
    },
    hulunbeier: {
        name: "内蒙古自治区呼伦贝尔市海拉尔区城头望园一号楼101门市",
        lonlat: [119.767398, 49.1663674]
    }

}
let map = null
onMounted(() => {
    mapboxgl.accessToken = accessToken; // 替换为你的API密钥
    map = new mapboxgl.Map({
        container: mapboxDom.value, // this.$el 是当前组件的根元素
        style: style, // 选择一个地图样式
        center: companyInfo.beijing.lonlat, // 设置初始中心点经纬度
        zoom: 15 // 设置初始缩放级别
    });

    addLabel(companyInfo.beijing)
    addLabel(companyInfo.zhengzhou)
    addLabel(companyInfo.xian)
    addLabel(companyInfo.hulunbeier)
    let elements = document.getElementsByClassName('mapboxgl-ctrl-logo')
    elements[0].style.display = 'none'

})

const handleClick = (region, num) => {
    active.value = num
    map.setCenter(region.lonlat);
    map.setZoom(15);
}


const addLabel = (region) => {
    const el = document.createElement('div');
    el.style.display = 'flex'
    el.style.alignItems = 'center'
    el.style.flexDirection = 'column'
    el.innerHTML = `
    <div class="company-web-name-label">${region.name}</div>
    <div class="company-web-name-img"></div>
  `;
    new mapboxgl.Marker({
        element: el,
        offset: [0, -40]
    }).setLngLat(region.lonlat)
        .addTo(map);
}

</script>

<style scoped lang="less">
.serve-content {
    font-family: 'PuHuiTi';
    width: 100%;
    height: 600px;
    overflow: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
}

.serve-content-content {
    width: 100%;
    height: 500px;

    box-shadow: 0px 1px 5px 0px rgba(185, 196, 218, .4);
    border-radius: 4px;
    display: flex;
    flex-direction: column;

}

.serve-content-content-left {
    background: #fff;
    display: flex;
    width: 100%;
    height: 150px;
    overflow: auto;
}

.serve-content-content-right {
    width: 100%;
    height: 100%;

}

.serve-content-content-left-content {
    width: 50%;
    height: 115px;
    padding: 10px;
    flex-shrink: 0;
    cursor: pointer;
}

.serve-content-content-left-content-name {
    font-size: 18px;
    margin-bottom: 5px;
}

.serve-content-content-left-content:hover {
    color: rgba(32, 129, 235, 1);
    border-top: 3px solid rgba(32, 129, 235, 1);
    background: rgba(32, 129, 235, 0.05);
}

.active {
    color: rgba(32, 129, 235, 1);
    border-top: 3px solid rgba(32, 129, 235, 1);
    background: rgba(32, 129, 235, 0.05);
}

.serve-content-phone {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

.serve-content-content-left::-webkit-scrollbar {
    height: 6px;
}

.serve-content-content-left::-webkit-scrollbar-thumb {
    background: #1890ff;
}

.serve-content-content-left::-webkit-scrollbar-track {
    background: #ffffff;
}
</style>
<style>
.company-web-name-img {
    width: 25px;
    height: 35px;
    margin-top: 5px;
    background-image: url("../../assets/image/coord.png");
    background-size: 100% 100%;
}

.company-web-name-label {
    background-color: #fff;
    padding: 10px 20px;
    font-size: 18px;
    border-radius: 10px;
}
</style>